export var hexToRgb = function (hex) {
    if (hex.length !== 7 || hex[0] !== '#') {
        throw new Error("Value " + hex + " is not a hex.");
    }
    var segments = hex.slice(1, 7).match(/.{1,2}/g);
    if (!segments) {
        throw new Error('Segments not formed');
    }
    return segments.map(function (segment) {
        var color = parseInt(segment, 16);
        if (isNaN(color)) {
            throw new Error("Segment " + segment + " is not valid.");
        }
        return color;
    });
};
//# sourceMappingURL=hexToRgb.js.map